import initHttp from './initHttp'
import initAuth from './initAuth'
import initRaven from './initRaven'
import initAnalytics from 'features/Analytics/Analytics.init'
import { getEntries } from 'features/Cms/Cms.actions'
import { listTemplates } from 'features/Flows/Flows.actions'
import { modalAction as messageModalAction } from 'features/Modal/MessageModal'

const isIE = () => {
  const ua = window.navigator.userAgent
  return ua.includes('MSIE ') || ua.includes('Trident/')
}

export default store => {
  initHttp(store)
  initAuth(store)
  initAnalytics(store)
  initRaven()

  // Pop a message modal if the user is on Internet Exporer
  if (isIE()) {
    store.dispatch(
      messageModalAction({
        title: "Sorry, IP HUB doesn't work well with Internet Explorer.",
        body: "Swap to Chrome, Firefox or Microsoft Edge and you'll be good to go.",
        noClickClose: true,
        hideClose: true,
      })
    )
  }

  // store.dispatch(getBillAttachments())
  // store.dispatch(getPaymentTerms())

  // The compulsory items are returned
  // The routing will not initialise until after these finish
  return Promise.all([
    store.dispatch(getEntries({ contentType: 'page' })),
    store.dispatch(getEntries({ contentType: 'redirect' })),
    store.dispatch(getEntries({ contentType: 'footer' })),
    store.dispatch(getEntries({ contentType: 'header' })),
    store.dispatch(getEntries({ contentType: 'product1300Plans' })),
    store.dispatch(getEntries({ contentType: 'product1800Plans' })),
    store.dispatch(getEntries({ contentType: 'productPhoneVpbxPlans' })),
    store.dispatch(getEntries({ contentType: 'productTwilioPlans' })),
    // store.dispatch(getEntries({ contentType: 'productPhoneVpbxHardware' })),
    store.dispatch(listTemplates()),
  ])
}



// WEBPACK FOOTER //
// ./src/app/init/index.js